/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const EvalSampleStatus = {
  Queued: "queued",
  Generating: "generating",
  ReadyToScore: "ready_to_score",
  Scoring: "scoring",
  Running: "running",
  Completed: "completed",
  Failed: "failed",
} as const;
export type EvalSampleStatus = ClosedEnum<typeof EvalSampleStatus>;

/** @internal */
export const EvalSampleStatus$inboundSchema: z.ZodNativeEnum<
  typeof EvalSampleStatus
> = z.nativeEnum(EvalSampleStatus);
/** @internal */
export const EvalSampleStatus$outboundSchema: z.ZodNativeEnum<
  typeof EvalSampleStatus
> = EvalSampleStatus$inboundSchema;
